import { LogLevel } from "@azure/msal-browser";

/**
 * Re-exported so callers and tests name levels rather than the integers MSAL
 * passes. Error 0, Warning 1, Info 2, Verbose 3, Trace 4.
 */
export const MSAL_LOG_LEVEL = {
  Error: LogLevel.Error,
  Warning: LogLevel.Warning,
  Info: LogLevel.Info,
  Verbose: LogLevel.Verbose,
  Trace: LogLevel.Trace,
} as const;

/**
 * What MSAL is allowed to put in a user's browser console.
 *
 * Errors and warnings are worth surfacing: they are the only signal a user or
 * a support conversation has when sign-in fails. Info and Verbose are MSAL's
 * internal tracing — useful while debugging the auth flow, noise for everyone
 * else — so they are dropped rather than downgraded.
 *
 * Getting them back takes two changes, not one: raise `logLevel` in the MSAL
 * config so MSAL emits them, *and* widen this switch so they are printed.
 * Raising `logLevel` alone changes nothing, because everything below Warning
 * falls through to `default`.
 *
 * A message flagged as containing PII is never logged at any level.
 */
export function msalLoggerCallback(level: LogLevel, message: string, containsPii: boolean): void {
  if (containsPii) return;

  switch (level) {
    case LogLevel.Error:
      console.error("MSAL:", message);
      break;
    case LogLevel.Warning:
      console.warn("MSAL:", message);
      break;
    default:
      break;
  }
}
